<template>
  <div class="row" v-if="page">
    <div class="col-md-4">
      <div class="dataTables_info" id="myTable_info" role="status" aria-live="polite">
        全 {{page.total}} 件中 {{ page.from }} 件 〜 {{ page.to }} 件を表示
      </div>
      <a href="#top" style="padding-left:10px;">ページトップに戻る</a>
    </div>
    <div class="col-md-8">
      <ul class="pagination">
        <li class="paginate_button page-item previous" :class="{'disabled': !hasPrev()}">
          <a tabindex="0" class="page-link" @click="changePage(1)">
            &lt;&lt;
          </a>
        </li>
        <li class="paginate_button page-item" :class="{'disabled': !hasPrev()}">
          <a tabindex="0" class="page-link" @click="changePage(page.current_page - 1)" :disabled="!hasPrev()">
            &lt;
          </a>
        </li>
        <template v-for="index in pages.slice().reverse()">
          <li :key="'prev-' + (index + 1)" class="paginate_button page-item" v-if="hasPrev(index + 1)">
            <a class="page-link" @click="changePage(page.current_page - (index + 1))">{{page.current_page - (index +
              1)}}</a>
          </li>
        </template>
        <li class="paginate_button page-item active">
          <span class="page-link">{{page.current_page}}</span>
        </li>
        <template v-for="index in pages.slice()">
          <li class="paginate_button page-item" v-if="hasNext(index + 1)" :key="'next-' + (index + 1)">
            <a class="page-link" @click="changePage(page.current_page + (index + 1))">{{page.current_page + (index +
              1)}}</a>
          </li>
        </template>
        <li class="paginate_button page-item" :class="{'disabled': !hasNext()}">
          <a tabindex="0" class="page-link" @click="changePage(page.current_page + 1)" :disabled="!hasNext()">
            &gt;
          </a>
        </li>
        <li class="paginate_button page-item next" :class="{'disabled': !hasNext()}">
          <a tabindex="0" class="page-link" @click="changePage(Math.ceil(page.total/page.per_page))">
            &gt;&gt;
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { range } from 'lodash'

// Define props
const props = defineProps({
  page: {
    type: Object,
    required: true
  }
})

// Define emits
const emit = defineEmits(['change'])

// Data
const pages = ref(range(10))

// Methods
const changePage = (page) => {
  emit('change', page)
}

const hasNext = (diff = 1) => {
  return props.page.last_page >= props.page.current_page + diff
}

const hasPrev = (diff = 1) => {
  return (props.page.current_page - diff) > 0
}
</script>

<style scoped>

</style>
